// src/components/AdminRoute.js
    import React from 'react';
    import { useAuth } from '../context/AuthContext';
    import { Navigate } from 'react-router-dom';

    function AdminRoute({ children }) {
      const auth = useAuth();

      // Jika pengguna bukan admin, arahkan mereka kembali ke halaman utama (dashboard)
      if (auth.user && auth.user.role !== 'admin') {
        return <Navigate to="/" />;
      }

      // Jika pengguna adalah admin, tampilkan halaman yang diminta
      return children;
    }

    export default AdminRoute;